import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {useSelector} from 'react-redux';
import {selectUserInfo, selectHasCrmPermission} from 'src/selectors/crm';
import {CRM_PERMISSIONS} from 'src/utils/crm-new/common';

import {
  PanelBody,
  PanelHeader,
} from '@spaced-out/ui-design-system/lib/components/Panel';
import {Banner} from '@spaced-out/ui-design-system/lib/components/Banner';

import {TypeAheadSelector} from 'src/components/crm/lib/typeAhead/typeahead';

import Evaluation from './evaluation';

import css from './on-behalf-evaluation.css';


const OnBehalfEvaluation = ({
  // @ts-expect-error - TS7031 - Binding element 'stepCandidate' implicitly has an 'any' type.
  stepCandidate,
  // @ts-expect-error - TS7031 - Binding element 'step' implicitly has an 'any' type.
  step,
  // @ts-expect-error - TS7031 - Binding element 'sections' implicitly has an 'any' type.
  sections,
  // @ts-expect-error - TS7031 - Binding element 'scorecard' implicitly has an 'any' type.
  scorecard,
  // @ts-expect-error - TS7031 - Binding element 'onCancel' implicitly has an 'any' type.
  onCancel,
  // @ts-expect-error - TS7031 - Binding element 'updateData' implicitly has an 'any' type.
  updateData,
}) => {
  const {t} = useLabelTranslation();
  const userDetails = useSelector(selectUserInfo);
  const hasAccessToSubmitOnBehalfOf = selectHasCrmPermission(
    userDetails,
    CRM_PERMISSIONS.EDIT_CANDIDATE_FEEDBACK_OTHER,
  );

  const {user: userInfo} = useSelector(selectUserInfo);
  const [reviewerId, setReviewerId] = React.useState(userInfo.id);
  const [reviewerName, setReviewerName] = React.useState(userInfo.username);

  const review =
    Array.isArray(stepCandidate.interviewReviews) &&
    stepCandidate.interviewReviews.find(
      // @ts-expect-error - TS7006 - Parameter 'review' implicitly has an 'any' type.
      (review) => review.reviewerId === reviewerId,
    );

  const checkIfReviewExists = (reviewerId: number) => {
    if (
      stepCandidate.interviewReviews.some(
        // @ts-expect-error - TS7006 - Parameter 'review' implicitly has an 'any' type.
        (review) => review.reviewerId === reviewerId,
      )
    ) {
      return true;
    }
    return false;
  };

  const [isViewMode, setViewMode] = React.useState(!!review);

  return (
    <PanelBody className={css.panelBody}>
      <Banner semantic="information">
        {t(
          'This_feedback_is_autosaved_as_a_draft_to_ensure_your_progress_isnt_lost',
          'This feedback is auto-saved as a draft to ensure your progress isn’t lost.',
        )}
      </Banner>
      <div className={css.onBehalfOfUser}>
        <TypeAheadSelector
          label={t('Submit_on_behalf_of', 'Submit on behalf of')}
          isApiCall
          isUserSearch
          typeAheadOptions={[]}
          placeholder={t('Select_user', 'Select user')}
          disabled={!hasAccessToSubmitOnBehalfOf}
          doNotShowOptionsIfNoResults={true}
          onSelectOption={(selectedUsers) => {
            if (selectedUsers && selectedUsers.length > 0) {
              const selectedUser = selectedUsers[0];
              // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'SetStateAction<number>'.
              setReviewerId(selectedUser.key);
              // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
              setReviewerName(selectedUser.label);
              if (checkIfReviewExists(Number(selectedUser.key))) {
                setViewMode(true);
              } else {
                setViewMode(false);
              }
            } else {
              // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'SetStateAction<number>'.
              setReviewerId('');
              setReviewerName('');
              setViewMode(false);
            }
          }}
          selectedOption={
            Boolean(reviewerId) && Boolean(reviewerName)
              ? [
                  {
                    key: reviewerId ? reviewerId.toString() : '',
                    label: reviewerName ? reviewerName : '',
                  },
                ]
              : []
          }
          isSingleSelect={true}
          nonDismissibleChips={true}
        />
      </div>

      {/* @ts-expect-error - TS2741 - Property 'scorecardConfigData' is missing in type '{ stepCandidate: any; review: any; onBehalfOfUserId: number; sections: any; scorecard: any; step: any; onCancel: any; isViewMode: boolean; setViewMode: Dispatch<SetStateAction<boolean>>; updateData: any; jobId: any; }' but required in type '{ review: any; onBehalfOfUserId: any; scorecard: any; sections: any; stepCandidate: any; step: any; onCancel: any; scorecardConfigData: any; isViewMode: any; setViewMode: any; updateData: any; jobId: any; }'. */}
      <Evaluation
        stepCandidate={stepCandidate}
        review={review}
        onBehalfOfUserId={reviewerId}
        sections={sections}
        scorecard={scorecard}
        step={step}
        onCancel={onCancel}
        isViewMode={isViewMode}
        setViewMode={setViewMode}
        updateData={updateData}
        jobId={stepCandidate.jobId}
        // @ts-expect-error - TS17001 - JSX elements cannot have multiple attributes with the same name.
        onBehalfOfUserId={reviewerId}
      />
    </PanelBody>
  );
};

export default OnBehalfEvaluation;
